import { useContext } from "react";
import { APIRequestGenerator } from "base/BaseActions";
import APIHelper from "base/APIHelper";
import BaseModel from "base/BaseModel";
import UserModel from "./userModel";

const module = "report";

const useReportModel = () => {
  const { token } = useContext(UserModel.Context);

  async function exportOne(data, params = null) {
    const { returnURL = false } = data;
    const { url, headers } = APIRequestGenerator(
      `${process.env.REACT_APP_HOST}/${module}/download`,
      params,
      token,
    );
    try {
      const response = await APIHelper(
        "POST",
        url.toString(),
        data,
        true,
        headers,
        false,
        !returnURL,
      );

      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  }

  return {
    exportOne,
  };
};

const ReportModel = BaseModel(useReportModel, "ReportModel");

export { useReportModel };
export default ReportModel;
